import React, { Component } from 'react';
import { Link } from 'react-router';

export default class SideBar extends Component {
	constructor(props) {
	  super(props);
	  this.state = {}
	  this.handleClick = this.handleClick.bind(this)
	}

	handleClick(e) {
		this.props.revealSidebar();
	}

  render() {
    const { logout, isAuthenticated, goToProfile, goToLogin } = this.props;

    return (
      <div className="SideBar">

        <div className="SideBar__item" onClick={this.handleClick}>
          <Link to="/">Home</Link>
        </div>
      
      	<div className="SideBar__item">
      		<Link to="https://open.spotify.com/artist/24r28WlEze44ZfRyJCTykU?si=a5ifafujQSqmDrbAxivRYA&dl_branch=1" target="_blank">
            Spotify
          </Link>
        </div>

      	<div className="SideBar__item" onClick={this.handleClick}>
	      	<Link to="/store">Store</Link>
	      </div>

        <div className="SideBar__item" onClick={this.handleClick}>
          <Link to="/presskit">Press Kit</Link>
        </div>

      	<div className="SideBar__item" onClick={this.handleClick}>
	      	<Link to="/contact">Contact</Link>
	      </div>
      	
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SideBar/SideBar.js